import React from "react";

function Spinner() {
  return (
    <div className="spinner-wrapper">
      <div className="spinner">
        <div className="bounce2"></div>
        <div className="bounce3"></div>
        <div className="bounce4"></div>
      </div>
    </div>
  );
}

export default Spinner;
